<div class="toast__container" role="region" aria-label="Notificaciones">
  @for (t of toasts(); track t.id) {
  <div
    class="toast"
    [ngClass]="'toast--' + t.variant"
    role="status"
    aria-live="polite"
    [style.--duration.ms]="t.duration"
  >
    <span class="toast__icon" aria-hidden="true"></span>

    <div class="toast__content">
      @if (t.title) {
      <div class="toast__title">{{ t.title }}</div>
      }
      <div class="toast__message">{{ t.message }}</div>
    </div>

    <button
      class="toast__close"
      (click)="dismiss(t.id)"
      aria-label="Cerrar notificación"
      type="button"
    >
      ×
    </button>

    <div
      class="toast__progress"
      [class.is-hidden]="t.duration <= 0"
      aria-hidden="true"
    ></div>
  </div>
  }
</div>
